import yup from '../../../config/yup';

export const lingkAdapterReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('lingkAdapterReader'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string(),
  format: yup.string(),
  onError: yup.string(),
  connectionKey: yup.string(),
  properties: yup.object().shape({
    rootUrl: yup.string(),
    url: yup.string().required('URL is required'),
    path: yup.string().required('Path is required'),
    httpMethod: yup
      .string()
      .oneOf(['GET', 'POST', 'PUT', 'DELETE'])
      .required('HTTP Method is required'),
    pageSize: yup.number().typeError('Page Size must be a number'),
    secret: yup.string(),
    explodeResult: yup.boolean(),
  }),
});
